module.exports = __webpack_public_path__ + "img/1543997159.13cbe726.jpg";